import React, { useRef, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "./header.css";
import NavBar from "../navBar/navBar";
import Container from "../container/container";
import AccountMenu from "../menu/accountMenu/accountMenu";
import PinControl from "./PinControl";
import { toggleHeaderPin } from "../../actions/headerPin";

const Header = (props) => {
  const {
    location,
    forcePinned = false,
    hidePinControl = false,
    disablePin = false,
  } = props;
  const dispatch = useDispatch();
  const headerRef = useRef(null);
  const [headerHeight, setHeaderHeight] = useState(170); // Spacer height equals actual header block height

  const isPinnedFromState = useSelector(
    (state) => state.headerPin?.pinnedPages?.[location] || false
  );
  const isPinned = disablePin ? false : forcePinned ? true : isPinnedFromState;

  const handleTogglePin = () => {
    if (disablePin) return;
    dispatch(toggleHeaderPin(location));
  };

  // Measure the header block and keep the spacer / --app-header-height in sync.
  // A ResizeObserver catches growth after mount (logo image, webfonts, account
  // menu content) that a one-off measurement would miss, leaving the pinned
  // header covering the top of the page.
  useEffect(() => {
    const headerEl = headerRef.current;
    if (!headerEl) return undefined;

    const measureHeight = () => {
      const rect = headerEl.getBoundingClientRect();
      const computedStyle = window.getComputedStyle(headerEl);
      const marginTop = parseFloat(computedStyle.marginTop) || 0;
      const marginBottom = parseFloat(computedStyle.marginBottom) || 0;
      const userHeaderEl =
        headerEl.querySelector(".user_header") ||
        document.querySelector(".user_header");
      const userHeaderHeight = userHeaderEl
        ? userHeaderEl.getBoundingClientRect().height
        : 0;

      const headerBlockHeight = rect.height + marginTop + marginBottom;
      setHeaderHeight(headerBlockHeight);
      // Expose header height as CSS variable for layout consumers
      try {
        document.documentElement.style.setProperty(
          "--app-header-height",
          `${headerBlockHeight + userHeaderHeight}px`
        );
      } catch (e) {
        // no-op
      }
    };

    measureHeight();
    window.addEventListener("resize", measureHeight);
    let observer;
    if (typeof ResizeObserver !== "undefined") {
      observer = new ResizeObserver(measureHeight);
      observer.observe(headerEl);
    }

    return () => {
      window.removeEventListener("resize", measureHeight);
      if (observer) observer.disconnect();
    };
  }, []);

  return (
    <>
      <header ref={headerRef} className={isPinned ? "header-pinned" : ""}>
        {!hidePinControl && (
          <PinControl isPinned={isPinned} onTogglePin={handleTogglePin} />
        )}
        <AccountMenu className="user_header" />
        <Container style={{ marginTop: 25 }}>
          <div className="pre_menu" />
        </Container>
        <NavBar location={location} />
        <div className="container after_menu" />
      </header>
      {isPinned && (
        <div
          className="header-spacer"
          style={{ height: `${headerHeight}px` }}
        />
      )}
    </>
  );
};

export default Header;
